import emptySliceApi from '../../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    updateDealName: builder.mutation<
      void,
      { accountId: string; dealId: string; name: string }
    >({
      query: ({ accountId, dealId, name }) => ({
        url: `v4/accounts/${accountId}/deals/${dealId}/name`,
        method: 'PUT',
        body: { name },
      }),
      invalidatesTags: ['Deal'],
    }),
  }),
});

export const { useUpdateDealNameMutation } = apiSlice;
